/**
 * Split client-side di una quantità venduta in parte da magazzino e parte da
 * approvvigionare. Mirror della logica backend (emma-maison-api → utils/splitQty),
 * usato per l'anteprima "Venduti / da ordinare" nei form preventivo PRIMA del
 * salvataggio (lo split autoritativo è ricalcolato dal server al save).
 *
 * @param {number} needNative      quantità venduta (unità nativa: scatole/pezzi)
 * @param {number} availableNative disponibilità magazzino (stessa unità)
 * @returns {{ warehouse: number, procure: number, needsProcurement: boolean }}
 */
export function splitQty(needNative, availableNative) {
  const need = Number(needNative) || 0;
  const available = Number(availableNative) || 0;
  const warehouse = Math.max(0, Math.min(need, Math.max(available, 0)));
  const procure = need - warehouse;
  return { warehouse, procure, needsProcurement: procure > 0 };
}

/**
 * Stato della cella "Consegnato" nel dettaglio preventivo (sc-47876).
 *
 * - "hidden"   → preventivo non confermato, nessuna cella
 * - "checkbox" → checkbox di consegna normale
 * - "blocked"  → checkbox disabilitata + bottone ORDINA: articolo di magazzino
 *                con quota ancora da ordinare
 *
 * Gli articoli Fuori Magazzino (sc-47879) sono consegnabili solo quando il
 * prodotto è "Arrivato". Le righe già consegnate mostrano comunque la checkbox
 * spuntata: il blocco vale solo per la transizione non consegnato → consegnato.
 *
 * @param {{ isConfirmed: boolean, isStock: boolean, isDelivered: boolean, quantityToProcure: number|string, outstockState?: string|null }} row
 * @returns {"hidden" | "checkbox" | "blocked"}
 */
export function deliveryCellState({
  isConfirmed,
  isStock,
  isDelivered,
  quantityToProcure,
  outstockState,
}) {
  if (!isConfirmed) return "hidden";
  // Le righe già consegnate mostrano sempre la checkbox spuntata (anche legacy).
  if (isDelivered) return "checkbox";
  // Fuori Magazzino (sc-47879): consegnabile solo quando il prodotto è "Arrivato".
  if (!isStock) return outstockState === "Arrivato" ? "checkbox" : "blocked";
  // Magazzino (sc-47876): bloccato finché c'è quota da ordinare.
  return Number(quantityToProcure || 0) > 0 ? "blocked" : "checkbox";
}

/**
 * [sc-49210] Opzioni del menu "Stato approvvigionamento" (AppSelect), con il
 * colore del pallino: condivise da Fuori Magazzino e dettaglio preventivo.
 */
export const outstockStateOptions = [
  { value: "Da Ordinare", label: "Da Ordinare", color: "#ef5350" },
  { value: "Ordinato", label: "Ordinato", color: "#ffa726" },
  { value: "Arrivato", label: "Arrivato", color: "#4caf50" },
];
